import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { LoadBalancerField } from './CreateLoadBalancerExtension';

export const CreateLoadBalancerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'LoadBalancerField',
    component: LoadBalancerField,
  }),
);
